module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Bold.825d4252.woff2";